import { render, staticRenderFns } from "./transferSubordinate.vue?vue&type=template&id=08aa6a60&scoped=true"
import script from "./transferSubordinate.vue?vue&type=script&lang=js"
export * from "./transferSubordinate.vue?vue&type=script&lang=js"
import style0 from "./transferSubordinate.vue?vue&type=style&index=0&id=08aa6a60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aa6a60",
  null
  
)

export default component.exports